import { Component, Input } from '@angular/core';



@Component({
  selector: 'ui-web-page-title',
  templateUrl: './ui-web-page-title.component.html'
})
export class UiWebPageTitleComponent {
  @Input({required: true}) pageTitle = '';
}
